module.exports = __webpack_public_path__ + "img/16.0fd9da30.png";